<template>
  <div class="sel-wrap">
    <button class="itp-item" v-for="item in chatTypeList" :key="item.type" @click="goToCreateChat(item.type)">
      <div :class="`icon-box ${item.type}`">
        <img :src="`/images/mobile/icon/${item.type}-icon.svg`" alt="" />
      </div>
      <span>{{ t(item.label) }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
const router = useRouter();
const { t } = useI18n();

const emit = defineEmits(['close']);

const chatTypeList = [
  {
    type: 'conference',
    label: 'label_conference',
  },
  {
    type: 'meeting',
    label: 'label_meeting',
  },

  {
    type: 'audience',
    label: 'label_audience',
  },
  {
    type: 'general',
    label: 'label_general',
  },
  {
    type: 'single',
    label: 'label_single',
  },
];

const goToCreateChat = (type) => {
  router.push(`/app/chat/new/${type}`);
  emit('close');
};
</script>

<style scoped lang="scss">
.sel-wrap {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1.5rem;
  padding: 1rem 0 1.25rem;
  .itp-item {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: $size-s;
    color: $color-gray-900;
    flex-shrink: 1;
    padding: 0;
    .icon-box {
      width: 100%;
      aspect-ratio: 1 / 1;
      min-width: 45px;
      min-height: 45px;
      max-width: 120px;
      max-height: 120px;
      border-radius: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      &.meeting {
        background: $meeting-bg;
      }
      &.conference {
        background: $conference-bg;
      }
      &.audience {
        background: $audience-bg;
      }
      &.general {
        background: $general-bg;
      }
      &.single {
        background: $single-bg;
      }
    }
    span {
      font-size: $font-size-xs;
      font-weight: 500;
    }
  }
}
</style>
